export default "__VITE_ASSET__RBUo5cTk__"